import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import type { Uuid } from '../unique-id-builder.ts'

/**
 * WARNING - This is admittedly a bit of a hack. FWIW this is all stand-in stuff for a proper CertificationType that hopefully doesn't
 * name collide with anything we do later. I tried to use namings that match our current database certification tags scheme.
 */

/**
 * CertificationKey
 */
export const [CertificationKeys, CertificationKeySchema, CertificationKeyEnum] =
  EnumBuilder(
    'linkedin-certified',
    'meta-certified',
    'mntn-certified',
    'qf-marketplace-certified',
    'qfai-certified',
    'tier-1-certified',
    'tiktok-certified'
  )
export type CertificationKey = ZodInfer<typeof CertificationKeySchema>

const certifications: {
  id: Uuid
  key: CertificationKey
  title: string
}[] = [
  // Production Certifications in QuickFrame Academy (https://quickframeacademy.com/pages/quickframe-academy)
  {
    id: '0198f714-1cb1-70fd-825d-5944cc5ea7ea',
    key: 'linkedin-certified',
    title: 'QuickFrame Marketplace LinkedIn Certificate',
  },
  {
    id: '09b5f28e-d75c-11ee-953f-061fddaab711',
    key: 'meta-certified',
    title: 'QuickFrame Meta Certificate',
  },
  {
    id: 'c95d2bb6-d77a-11ee-97cf-02ab00d03d4f',
    key: 'mntn-certified',
    title: 'QuickFrame MNTN Certificate',
  },
  {
    id: '0196c650-c98e-7f2a-875c-8249a8f2959d',
    key: 'qf-marketplace-certified',
    title: 'QuickFrame Marketplace Certificate',
  },
  {
    id: '019c58b0-2ff4-7af1-bb6c-0e2451670659',
    key: 'qfai-certified',
    title: 'QuickFrame AI Certificate',
  },
  {
    id: '018f9d83-7cea-7026-82e5-1aee98dda2cc',
    key: 'tiktok-certified',
    title: 'QuickFrame TikTok Certificate',
  },
  // Development Certifications in Demo University (https://mntn-hub-4.workramp.io/certifications)
  {
    id: '01962502-d41b-76e8-bc35-58964e0478a0',
    key: 'qf-marketplace-certified',
    title: 'QuickFrame General Onboarding Test',
  },
]

/** This a map to get a Certification key from the WorkRamp Certification Id. */
export const WorkrampCertificationIdToTagKeyMap = Object.fromEntries(
  certifications.map(({ id, key }) => [id, key])
) as Record<Uuid, CertificationKey>

/** This is a reverse map of WorkrampCertificationIdToMap. To get the WorkRamp Certification Id from Certification key. */
export const TagKeyToWorkrampCertificationIdMap = Object.fromEntries(
  certifications.map(({ id, key }) => [key, id])
) as Record<CertificationKey, Uuid>

/** This a map to get a Certification key from the WorkRamp Certification Title. */
export const WorkrampTitleToTagKeyMap = Object.fromEntries(
  certifications.map(({ title, key }) => [title, key])
) as Record<string, CertificationKey>
